export function ngDebounce(timeout: number, cancelDebounce?: CallableFunction) {
  // store timeout value for cancel the timeout
  let timeoutRef = null;

  return function (target, propertyKey: string, descriptor: PropertyDescriptor) {

    // store original function for future use
    const original = descriptor.value;

    // override original function body
    descriptor.value = function debounce(...args) {

      // clear previous timeout
      clearTimeout(timeoutRef);

      // sechudle timer
      timeoutRef = setTimeout(() => {

        // call original function
        original.apply(this, args);

      }, timeout);

      // define a property to cancel existing debounce timmer
      Object.defineProperty(debounce, "cancelDebounce", {
        value: function () {
          clearTimeout(timeoutRef);
        },
        configurable: true
      });

    }

    // return descriptor with new value
    return descriptor;
  }
}